import { render } from "./IndustrialGroupedBilling.vue?vue&type=template&id=059c2eb5"
import script from "./IndustrialGroupedBilling.vue?vue&type=script&lang=js"
export * from "./IndustrialGroupedBilling.vue?vue&type=script&lang=js"

import "./IndustrialGroupedBilling.vue?vue&type=style&index=0&id=059c2eb5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__